// src/routes/RoleBasedRedirect.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // Importar useAuth

function RoleBasedRedirect() {
  const { token, role } = useAuth(); // Obtener token y role desde el contexto

  // Si no hay token => a login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Si hay token, decide a dónde ir según el rol
  if (role === "ADMIN") {
    return <Navigate to="/admin" replace />;
  } else if (role === "CLIENT_ADMIN") {
    return <Navigate to="/client-dashboard" replace />;
  } else if (role === "CLIENT_USER") {
    return <Navigate to="/reports/sales/distances" replace />;
  } else {
    // Rol no reconocido
    return <Navigate to="/login" replace />;
  }
}

export default RoleBasedRedirect;
